import { render, staticRenderFns } from "./TextContentMediaSelection.vue?vue&type=template&id=9cdbb4ce&scoped=true"
import script from "./TextContentMediaSelection.vue?vue&type=script&lang=js"
export * from "./TextContentMediaSelection.vue?vue&type=script&lang=js"
import style0 from "./TextContentMediaSelection.vue?vue&type=style&index=0&id=9cdbb4ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbb4ce",
  null
  
)

export default component.exports